import { FC, useRef } from "react";
import { useLocalization } from "@store/localizationStore";
import { usePageTitle } from "@utils/PageTitleHook";
import { urlConstants } from "@constants/urlConstants";
import { AttrNames } from "@utils/AttrMapping";
import { ISubjektModel, SubjektAttrMap } from "@models/ISubjektModel";
import RegistryZadavateluFilter from "./RegistryZadavateluFilter";
import { columnWidths, ListFrame, ListFrameColumns } from "@components/ListFrame";
import ContentBlock from "@components/ContentBlock";
import Paginator from "@components/Pagination";
import { detailLinks } from "@constants/detailLinks";
import { useDescription } from "@utils/DescriptionHook";
import { useOrderByMemo } from "@utils/OrderByUtils";

export const ON_PAGE_ROWS = 50;

const columns: ListFrameColumns<ISubjektModel> = [
    {
        attrName: 'nazevOrganizace',
        locKey: 'NEN-812506',
        width: '200%'
    },
    {
        attrName: 'ico',
        locKey: 'NEN-812508',
        width: columnWidths.ico
    },
    {
        attrName: 'kategorieZadavatele',
        locKey: 'NEN-812532',
    },
    {
        attrName: 'nutsKod',
        locKey: 'NEN-812777',
    }
];

const registrZadavateluLoadKey = 'registr-zadavatelu-seznam';
const paramNames = urlConstants.registrZadavatelu.paramNames;
const fulltextAttributes: AttrNames<ISubjektModel> = ['nazevOrganizace', 'ico', 'nutsKod'];

const RegistrZadavatelu: FC = () => {
    const { t } = useLocalization();
    usePageTitle(t('NEN-602386'));
    useDescription(t('NEN-789443'));

    const frameContainer = useRef<HTMLDivElement>(null);

    return (
        <>
            <h2 className='u-sr-only'>{t('NEN-602386')}</h2>
            <ContentBlock>
                <RegistryZadavateluFilter id={registrZadavateluLoadKey} paramNames={paramNames} />
                <ListFrame
                    listFrameKey={registrZadavateluLoadKey}
                    condition="(Zadavatel = true or sdruzeni_zadav = true) and Plati_DO = null and vedouci_sdruzeni=null"
                    paramNames={paramNames}
                    fulltextAttributes={fulltextAttributes}
                    orderBy={useOrderByMemo<ISubjektModel>("nazevOrganizace", { desc: true, column: "id" })}
                    onPageCount={ON_PAGE_ROWS}
                    skeletonCount={ON_PAGE_ROWS}
                    attrMapping={SubjektAttrMap}
                    detailLinkFactory={detailLinks.getDetailSubjektLinkFactory()}
                    columns={columns} />
            </ContentBlock>
            <Paginator
                loadMoreButton
                scrollToRef={frameContainer}
                collectionKey={registrZadavateluLoadKey} />
        </>
    );
}

export default RegistrZadavatelu;
